import { faEye, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import CreateNoteModal from './CreateNoteModal'
import { useDispatch } from 'react-redux'
import { getApplicationNotes } from 'store/Recruitment/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteApplicationNote } from 'store/Recruitment/actions'
import { setFormSubmitted } from 'store/Recruitment/actions'

function Notes() {
  const dispatch = useDispatch()
  const location = useLocation()

  const { applicationNotes } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState(false)

  const [note, setNote] = useState(null)

  const columns = [
    {
      headerName: 'Created By',
      field: 'created_by',
    },
    {
      headerName: 'Description',
      field: 'description',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Action',
      field: 'action',
      unSortIcon: false,
      sortable: false,
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faPencil}
            title='Edit'
            role='button'
            className='text-info'
            onClick={() => {
              setShowModal(true)
              setNote(params.data)
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () =>
                    dispatch(
                      deleteApplicationNote(
                        params.data.id,
                        location?.search?.split('=')?.at(1)
                      )
                    ),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    dispatch(getApplicationNotes(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  useEffect(() => {
    if (!showModal) {
      dispatch(setFormSubmitted(false))
      setNote(null)
    }
  }, [showModal, dispatch])

  return (
    <Card>
      <CardHeader className='title d-flex justify-content-between align-items-center'>
        Notes
        <button className='btn btn-info' onClick={() => setShowModal(true)}>
          + Create Note
        </button>
      </CardHeader>
      <CardBody>
        <div
          className='ag-theme-alpine'
          style={{ height: '600px', width: '100%' }}
        >
          <AgGridReact
            columnDefs={columns}
            rowData={applicationNotes}
            defaultColDef={defaultColDef}
          />
        </div>
      </CardBody>
      {showModal && (
        <CreateNoteModal
          showModal={showModal}
          setShowModal={setShowModal}
          note={note}
        />
      )}
    </Card>
  )
}

export default Notes
